import { actionRequiredFilterReducer } from '@sde/core/src/state/actionRequiredFilter';

export const reducers = {
  actionRequiredFilter: actionRequiredFilterReducer,
};
